var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home-page page"},[_c('HomeBannerComponent'),_c('HomeAnnouncementsComponent'),_c('HomePostersPaginationComponent'),_c('HomeGalleriesComponent'),_c('HomeLinksComponent'),_c('HomeAdditionalComponent'),_c('HomeTelegramComponent'),_c('HomeGovernmentComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }